"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.shareButtons = exports.FacebookShareButton = exports.TwitterShareButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fa = require("react-icons/fa");

var _styledComponents = require("rebass/styled-components");

var _Button = _interopRequireDefault(require("../Button"));

var _Text = _interopRequireDefault(require("./Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TwitterShareButton = function TwitterShareButton(_ref) {
  var message = _ref.message,
      url = _ref.url,
      hashtags = _ref.hashtags,
      via = _ref.via,
      inReplyTo = _ref.inReplyTo,
      props = _objectWithoutProperties(_ref, ["message", "url", "hashtags", "via", "inReplyTo"]);

  var twitterLinkGenerated = (0, _react.useMemo)(function () {
    var href = 'https://twitter.com/intent/tweet?';
    href += "text=".concat(encodeURIComponent(message));

    if (url !== '') {
      href += "&url=".concat(encodeURIComponent(url));
    }

    if (hashtags !== '') {
      href += "&hashtags=".concat(encodeURIComponent(hashtags));
    }

    if (via !== '') {
      href += "&hashtags=".concat(encodeURIComponent(via));
    }

    if (inReplyTo !== '') {
      href += "&in-reply-to=".concat(encodeURIComponent(inReplyTo));
    }

    return href;
  }, [message, url, hashtags, via, inReplyTo]);
  return _react.default.createElement(_styledComponents.Link, {
    href: twitterLinkGenerated
  }, _react.default.createElement(_Button.default, _extends({}, props, {
    variant: "twitterShare"
  }), _react.default.createElement(_fa.FaTwitter, null), _react.default.createElement(_Text.default, {
    as: "span",
    pl: 2
  }, "Tweet")));
};

exports.TwitterShareButton = TwitterShareButton;

var FacebookShareButton = function FacebookShareButton(_ref2) {
  var url = _ref2.url,
      props = _objectWithoutProperties(_ref2, ["url"]);

  var href = 'https://www.facebook.com/sharer/sharer.php?';
  href += "&u=".concat(encodeURIComponent(url));
  return _react.default.createElement(_styledComponents.Link, {
    href: href
  }, _react.default.createElement(_Button.default, _extends({}, props, {
    variant: "facebookShare"
  }), _react.default.createElement(_fa.FaFacebook, null), _react.default.createElement(_Text.default, {
    as: "span",
    pl: 2
  }, "Share")));
};

exports.FacebookShareButton = FacebookShareButton;
FacebookShareButton.propTypes = {
  url: _propTypes.default.string
};
var shareButtons = {
  TwitterShareButton: TwitterShareButton,
  FacebookShareButton: FacebookShareButton
};
exports.shareButtons = shareButtons;
var _default = shareButtons;
exports.default = _default;